<template>
  <div class="billApply">
    <h3>发票申请</h3>
    <div class="content">
      <div class="top">
        <div class="left">
          <label for="">
            <span>发票金额：</span>
            <input type="text" v-model="info.money" @blur="num">
            <p class="limit">可开额度{{maxPrice}}元，满109元包邮</p>
          </label>
          <label for="">
            <span>发票内容：</span>
            <span class="con">服务费</span>
          </label>
        </div>
        <div class="right">
          <label class="sex">
            <span>发票类型：</span>
            <p class="man"  v-if="sex == 0"><img src="../../../assets/images/courier/xuanzhong.png" alt="" @click="handleClick(0)">个人</p>
            <p class="man"  v-else><img src="../../../assets/images/courier/meixuan.png" alt=""  @click="handleClick(0)">个人</p>
            <p class="women" v-if="sex == 0"><img src="../../../assets/images/courier/meixuan.png" alt=""  @click="handleClick(1)">公司</p>
            <p class="women" v-else><img src="../../../assets/images/courier/xuanzhong.png" alt=""  @click="handleClick(1)">公司</p>
          </label>
          <label for="">
            <span>{{sex == 0 ? '姓名' : '公司名称'}}：</span>
            <input type="text" :placeholder="sex == 0 ? '请输入开票人姓名' : '请输入公司全称'" v-model="info.name">
          </label>
        </div>
      </div>
      <div class="bottom">
        <div class="item">
          <label for="" class="choice">
            <span>选择邮寄发票的快递：</span>
            <div class="down" @click="showExpress">
              <div>
                <input type="text" readonly placeholder="请选择" v-model="info.express">
                <img src="../../../assets/images/login/xiasanjiao.png" alt="">
              </div>
              <ul v-if="isExpress">
                <li v-for="(item, index) in expressList" :key="index" @click="checkedItem">{{item}}</li>
              </ul>
            </div>
          </label>

          <p class="title">请选择收货地址</p>
          <div class="address">
            <div class="line">
              <label for="">
                <span class="info">收件地址:</span>
                <area-city @city="city" />
              </label>
              <label for="">
                <span class="info">详细地址:</span>
                <input type="text" placeholder="楼层、门牌号" v-model="info.detaileAddress">
              </label>
              <!--地图-->
              <div id="allmap"  class="allmap"></div>
            </div>
            <label for="">
              <span>备注信息:</span>
              <textarea name="" id="" cols="30" rows="10" placeholder="请输入物品名称" v-model="info.remark"></textarea>
            </label>
          </div>

        </div>
        <div class="way">
          <h5 class="manner">邮寄方式</h5>
          <p>快递（到付）</p>
          <p>发票金额少于109元时使用快递到付邮寄</p>
          <div class="agree">
            <img v-if="isSelect" src="../../../assets/images/courier/select.png" alt="" @click="select">
            <img v-else src="../../../assets/images/courier/meixuanzhong.png" alt="" @click="select">
            <span>我已同意并阅读</span>
            <span>《发票说明》</span>
          </div>
        </div>
        <button @click="commit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import AreaCity from '../../../components/AreaCity'
import {init} from '../../../utils/map'
import {reqExpress, reqApply} from '../../../api'
export default {
  data () {
    return {
      info: {
        money: '', // 金额
        name: '', // 公司名称
        express: '', // 快递
        address: [], // 地址
        detaileAddress: '', // 详细地址
        remark: '' // 备注
      },
      isExpress: false,
      expressList: [],
      sex: 0,
      maxPrice: '',
      isSelect: false // 是否同意阅读发票
    }
  },
  mounted () {
    init('深圳', 'allmap')
    // 获取快递类型
    reqExpress().then(res => {
      if(res.code === 200){
        this.expressList = res.data.bussData.svalue.split(/\r\n/)
      }
    })
    // 获取最大发票金额
    this.maxPrice = this.$route.query.price
  },
  methods: {
    // 检测发票金额的最大值
    num() {
      if(Number(this.info.money) || Number(this.info.money) === 0){
        if(Number(this.info.money) > Number(this.maxPrice)){
          this.$message({
            message: '输入的金额过大',
            type: 'error'
          })
          this.info.money = ''
        }
      }else{
        this.$message({
          message: '输入纯数字金额',
          type: 'error'
        })
        this.info.money = ''
      }

    },
    // 根据地址名称更换地图
    getAddress (e) {
      let type = e.target.parentNode.nextElementSibling.nextElementSibling.id
      if(!e.target.value) return
      init(e.target.value, type)
    },
    // 显示快递列表
    showExpress() {
      this.isExpress = !this.isExpress
    },
    // 选择快递单个
    checkedItem(e) {
      this.info.express = e.target.innerText
    },
    // 是否同意阅读发票
    select() {
      this.isSelect = !this.isSelect
    },
    // 申请发票
    commit() {
      if(!this.info.money){
        this.$message({
          message: '发票金额不能为空',
          type: 'error'
        })
      }else if(!this.info.name){
        this.$message({
          message: '请输入姓名或者公司名称',
          type: 'error'
        })
      }else if(!this.info.express){
        this.$message({
          message: '请选择发货快递',
          type: 'error'
        })
      }else if(!this.info.address.length){
        this.$message({
          message: '请选择城市',
          type: 'error'
        })
      }else if(!this.info.detaileAddress){
        this.$message({
          message: '请填写详细地址',
          type: 'error'
        })
      }else if(!this.isSelect){
        this.$message({
          message: '请阅读发票说明并打钩',
          type: 'error'
        })
      } else {
        reqApply(this.info).then(res => {
          if(res.code === 200) {
            let invoiceMoney = parseInt(this.$store.state.userBaseInfo.invoiceMoney - Number(this.info.money))
            this.$store.dispatch('changeInvoice', {invoiceMoney, bool: 'false'})
            this.$message({
              message: '申请成功',
              type: 'success'
            })
            this.$router.replace('/person/bill')
          }
        })
      }
    },
    city(city) {
      this.info.address = city
    },
    handleClick (i) {
      this.sex = i
    }
  },
  components: {
    AreaCity

  }
}
</script>

<style scoped lang="less" type="text/less">
  .billApply{
    h3{
      margin-top:60px;
      font-size: 24px;
    }
    .content{
      margin-top:39px;
      .top{
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;
        border-bottom: 1px solid #e1e1e1;
        label{
          display: block;
          margin-bottom: 19px;
          span{
            display: inline-block;
            width: 75px;
            text-align: center;
            &.con{
              text-align: left;
            }
          }
          input{
            width: 340px;
            height: 36px;
            border:1px solid #e1e1e1;
            text-indent: 10px;
          }
          .limit{
            margin-left: 78px;
            margin-top:10px;
            color:#999;
          }
          &.sex{
            display: flex;
            align-items: center;
            p{
              margin-right: 33px;
              img{
                margin-right: 5px;
                vertical-align: text-bottom;
                cursor: pointer;
              }
            }
          }
        }
      }
      .bottom{
        padding-top: 20px;
        .choice{
          display: flex;
          position: relative;
          line-height: 38px;
          .down{
            position: relative;
            width: 340px;
            height: 38px;
            input{
              width: 338px;
              height: 36px;
              border:1px solid #e1e1e1;
              text-indent: 10px;
              cursor: pointer;
            }
            img{
              position: absolute;
              top: 17px;
              right: 14px;
              cursor: pointer;
            }
            ul{
              position: absolute;
              top: 40px;
              width: 100%;
              z-index: 999;
              line-height: 40px;
              text-indent: 10px;
              background: #fff;
              box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);
              li{
                border-bottom: 1px dotted #e1e1e1;
                cursor: pointer;
              }
            }
          }

        }
        .title{
          font-size: 16px;
          font-weight: bold;
          margin-top:30px;
        }
        .address{
          margin-top:19px;
          .line{
            border-right: 1px solid #f1f1f1;
          }
          label{
            display: flex;
            margin-bottom: 20px;
            span{
              display: block;
              width: 75px;
              text-align: right;
              line-height: 36px;
              margin-right: 12px;
            }
            input{
              width: 350px;
              height: 40px;
              border:1px solid #e1e1e1;
              box-sizing: border-box;
              text-indent: 10px;
              border-radius: 4px;
              &:focus{
                outline: none;
              }
            }
            .hisCheck{
              width:100px;
              height:40px;
              background:#61aee6;
              border:none;
              color:#fff;
              cursor: pointer;
            }
            textarea{
              width: 350px;
              height: 100px;
              padding:13px 10px;
              box-sizing: border-box;
              resize:none;
              border:1px solid #e1e1e1;
              border-radius: 4px;
              &::-webkit-input-placeholder{
                color:#c0c4cc;
              }
            }
          }

        }
        .way{
          margin-top:30px;
          h5{
            font-size: 16px;
            font-weight: bold;
          }
          p{
            margin-top:19px;
          }
          .agree{
            margin-top:19px;
            img{
              vertical-align: middle;
            }
            span{
              &:last-of-type{
                color:#2FA1DE;
              }
            }
          }
        }
        button{
          width: 332px;
          height: 48px;
          margin-top:30px;
          border:none;
          box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
          border-radius:24px;
          background: #61aee6;
          color:#fff;
        }
      }
    }
    /*地图大小*/
    .allmap {
      width: 511px;
      height: 261px;
      margin-bottom: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/BillApply.vue